export default function HostLandingPage() {
    return (
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white text-gray-800 flex flex-col items-center p-6">
        {/* Custom CSS for vertical numbering */}
        <style jsx>{`
          .vertical-numbers {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2rem;
            counter-reset: step-counter;
          }
          .vertical-numbers li {
            position: relative;
            padding-left: 3.5rem;
            counter-increment: step-counter;
            list-style: none;
          }
          .vertical-numbers li:before {
            content: counter(step-counter);
            position: absolute;
            left: 0;
            top: 0;
            width: 2.5rem;
            height: 2.5rem;
            background: #3b82f6;
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            font-size: 1.1rem;
          }
          .vertical-numbers li:not(:last-child):after {
            content: "";
            position: absolute;
            left: 1.25rem;
            top: 2.5rem;
            width: 2px;
            height: calc(100% + 2rem);
            background: #3b82f6;
          }
        `}</style>
  
        <header className="text-center mb-12 max-w-3xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight">
            <span className="text-blue-700">Become a Host</span>{" "}
            <span className="text-orange-600">with Pay2Pee</span>
          </h1>
          <p className="text-xl text-gray-600 font-medium mb-8">
            Join our growing network of hosts and turn your restroom into a revenue stream
          </p>
          <div className="bg-orange-100 border-l-4 border-orange-500 p-4 mb-8">
            <p className="text-orange-700 font-semibold">
              We're looking for early adopters! Limited spots available.
            </p>
          </div>
        </header>
  
        <section className="bg-white rounded-xl shadow-lg p-8 max-w-4xl w-full mb-12">
          <h2 className="text-3xl font-bold mb-8 text-center">
            <span className="text-blue-700">Why Become a</span>{" "}
            <span className="text-orange-600">Pay2Pee Host?</span>
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* Left Column */}
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <div className="flex items-center justify-center h-6 w-6 rounded-full bg-blue-100 text-blue-800">
                    ✓
                  </div>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-semibold text-gray-900">Passive Income</h3>
                  <p className="mt-1 text-gray-600">
                    Earn money effortlessly by allowing verified guests to use your restroom.
                  </p>
                </div>
              </div>
  
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <div className="flex items-center justify-center h-6 w-6 rounded-full bg-blue-100 text-blue-800">
                    ✓
                  </div>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-semibold text-gray-900">Increased Foot Traffic</h3>
                  <p className="mt-1 text-gray-600">
                    Attract more visitors who may become customers for your primary business.
                  </p>
                </div>
              </div>
  
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <div className="flex items-center justify-center h-6 w-6 rounded-full bg-blue-100 text-blue-800">
                    ✓
                  </div>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-semibold text-gray-900">Verified Users Only</h3>
                  <p className="mt-1 text-gray-600">
                    All guests are verified through our platform for your peace of mind.
                  </p>
                </div>
              </div>
            </div>
  
            {/* Right Column */}
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <div className="flex items-center justify-center h-6 w-6 rounded-full bg-blue-100 text-blue-800">
                    ✓
                  </div>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-semibold text-gray-900">Complete Control</h3>
                  <p className="mt-1 text-gray-600">
                    Set your own hours, prices, and access rules that work for your business.
                  </p>
                </div>
              </div>
  
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <div className="flex items-center justify-center h-6 w-6 rounded-full bg-blue-100 text-blue-800">
                    ✓
                  </div>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-semibold text-gray-900">Community Service</h3>
                  <p className="mt-1 text-gray-600">
                    Help delivery drivers, travelers, and others find clean, safe facilities.
                  </p>
                </div>
              </div>
  
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <div className="flex items-center justify-center h-6 w-6 rounded-full bg-blue-100 text-blue-800">
                    ✓
                  </div>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-semibold text-gray-900">Easy Setup</h3>
                  <p className="mt-1 text-gray-600">
                    Get started in minutes with our simple onboarding process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
  
        <section className="bg-white rounded-xl shadow-lg p-8 max-w-4xl w-full mb-12">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold mb-2">
              <span className="text-blue-700">How It</span>{" "}
              <span className="text-orange-600">Works</span>
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Becoming a host is simple and takes just a few minutes to set up
            </p>
          </div>
          
          {/* Vertical Numbered Steps */}
          <div className="flex justify-center">
            <ol className="vertical-numbers max-w-md w-full">
              <li className="pb-8">
                <h3 className="font-semibold text-lg mb-2">Sign Up</h3>
                <p className="text-gray-600">
                  Complete our simple application form with your business details
                </p>
              </li>
              <li className="pb-8">
                <h3 className="font-semibold text-lg mb-2">List Your Space</h3>
                <p className="text-gray-600">
                  Add your restroom details, availability, and pricing
                </p>
              </li>
              <li>
                <h3 className="font-semibold text-lg mb-2">Start Earning</h3>
                <p className="text-gray-600">
                  Get notified when guests book and collect payments automatically
                </p>
              </li>
            </ol>
          </div>
        </section>
  
        <section className="bg-gradient-to-r from-blue-700 to-blue-600 rounded-xl shadow-lg p-8 max-w-4xl w-full mb-12 text-white">
          <div className="text-center mb-6">
            <h2 className="text-3xl font-bold mb-4">
              <span>Ready to</span>{" "}
              <span className="text-orange-300">Get Started?</span>
            </h2>
            <p className="text-blue-100 max-w-2xl mx-auto">
              Join our network of hosts today and start earning from your underutilized space
            </p>
          </div>
          
          <div className="bg-white rounded-lg p-1 max-w-2xl mx-auto">
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSdDicLAMMRxp6bacO65q0rlpA_q1qcyU-79vq691JXI-Wholw/viewform?embedded=true"
              width="100%"
              height="900"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Pay2Pee Host Signup"
              className="rounded-lg"
            >
              Loading…
            </iframe>
          </div>
        </section>
  
        <footer className="text-sm text-gray-600 mt-auto text-center">
          <p>Questions? Contact us at <a href="mailto:admin@pay2pee.app" className="text-blue-700 font-semibold hover:underline">admin@pay2pee.app</a></p>
          <p className="mt-2">© {new Date().getFullYear()} Pay2Pee. All rights reserved.</p>
        </footer>
      </div>
    );
  }